import React, { useCallback, useRef, useState } from 'react';
import { isMobile } from 'is-mobile';
import {
  useRegisterViewportSizeListeners,
  UseRegisterViewportSizeListenersParams,
} from '../hooks/use-register-viewport-size-listeners.hook';

// import useViewportSize from '../hooks/use-viewport-size.hook';

type ChatViewportProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export function ChatViewport({ style = {}, ...rest }: ChatViewportProps) {
  const animationFrameRequest = useRef<number | null>(null);
  const [maxHeight, setMaxHeight] = useState<number>(window?.visualViewport?.height || window?.innerHeight || 0);

  // Fix for on-screen keyboard in mobile devices
  // This will reduce the max height of the chat component so it takes only the visible size of the viewport
  const onViewportChange: UseRegisterViewportSizeListenersParams['onViewportChange'] = useCallback((s) => {
    if (isMobile({ tablet: true, featureDetect: true })) {
      if (animationFrameRequest.current !== null) {
        cancelAnimationFrame(animationFrameRequest.current);
      }
      animationFrameRequest.current = requestAnimationFrame(() => {
        setMaxHeight(s.height);
      });
    }
  }, []);
  useRegisterViewportSizeListeners({
    onViewportChange,
  });

  const s: React.CSSProperties = {
    ...style,
    ...(maxHeight ? { maxHeight: `${maxHeight}px` } : { maxHeight: undefined }),
  };
  return <div style={s} {...rest} />;
}
